(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.searchDetails = this.querySelector("details-modal.header__search");
      this.drawer = this.querySelector("header-drawer");

      this.searchSummaryToggles = this.querySelectorAll('.header__icon--summary.header__icon--search:not(.search_toggle)');
      this.searchSummaryToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.onSummaryClick.bind(this));
      });

      this.drawerSummaryToggles = this.querySelectorAll('.header__icon--summary.header__icon--menu');
      this.drawerSummaryToggles.forEach((toggle) => {
        toggle.addEventListener('click', this.onDrawerClick.bind(this));
      });

      /* Mega Menu + All type hover */ 
      this.megaMenuMenus = this.querySelectorAll("header-menu");
      this.megaMenuDetails = this.querySelectorAll(".mega-menu");
      this.debouncedMMDetailsToggle = debounce((event) => {
            this.onMMDetailsToggle(event);
      }, 200);
      this.megaMenuDetails.forEach((details) => {
          details.addEventListener('toggle', this.onMMDetailsToggle.bind(this));
      })
      this.megaMenuMenus.forEach((menu) => {
        this.hover(menu, e => {
          // On hover
          menu.querySelector("details").setAttribute("open", "");
          menu.querySelector("details > summary").setAttribute("aria-expanded", "true");
        }, throttle(e => {
          // On hover leave
          menu.querySelector("details").removeAttribute("open", "");
          menu.querySelector("details > summary").setAttribute("aria-expanded", "false");
        }), 100);
      });

      this.createObserver();
    }
    

    onMMDetailsToggle(event) {
      if (event && event.newState == 'open') {
      let menuItems = event.target.querySelectorAll(".mega-menu__list .grandchild-list");
        menuItems.forEach((menuItem) => {
          let height = 0;
          let linkItems = menuItem.children;
          if (typeof linkItems !== 'undefined' && linkItems.length > 10) {
            for (let i = 0; i <= 10; i++) {
              let itemStyles = window.getComputedStyle(linkItems[i].firstElementChild);
              let itemPadding = parseFloat(itemStyles.paddingTop) + parseFloat(itemStyles.paddingBottom);
              let itemHeight = linkItems[i].firstElementChild.offsetHeight;
              height += itemHeight;
            }
            menuItem.style.maxHeight = (height + 5) + "px";
          }
          
        });
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    hover(element, enter, leave){
      element.addEventListener('mouseenter', enter)

      element.addEventListener('mouseleave', leave)
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.searchDetails != null){
        this.searchDetails.onSummaryClick(event);
      }
    }

    onDrawerClick(event) {
      this.drawer.onSummaryClick(event);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);

      let resizeObserver = new ResizeObserver((entries, observer) => {
          if (typeof this.megaMenuDetails !== 'undefined') {
            this.megaMenuDetails.forEach((details) => {
              this.onMMDetailsToggle();
            });
          }
      });

      resizeObserver.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
